import { InjectionToken } from '@angular/core';

export interface SalesCreditNoteConfig {
  apiUrl: string;
}

/** Creates a document module configuration injection token */
export const SALES_CREDIT_NOTE_CONFIG = new InjectionToken<SalesCreditNoteConfig>('SalesCreditNoteConfig');
